// Словарь подпроекта 10 «Кабинет клиента». Тексты самого кабинета (`ruCabinet`) берёт приложение `apps/cabinet` через
// лёгкий вход `@glory/i18n/cabinet`; ошибки, «История» и блок в карточке клиента подключаются в `ru.ts`.

/** Кабинет клиента (`apps/cabinet`). */
export const ruCabinet = {
  title: 'Личный кабинет',
  documentTitle: 'Личный кабинет — {studio}',
  login: {
    title: 'Вход в личный кабинет',
    lead: 'Пароль не нужен — пришлём код на почту',
    email: 'Почта',
    emailPlaceholder: 'name@company.ru',
    getCode: 'Получить код',
    codeTitle: 'Введите код из письма',
    codeLead: 'Отправили 6 цифр на {email}. Код действует {minutes} минут',
    code: 'Код',
    signIn: 'Войти',
    otherEmail: 'Другая почта',
    resend: 'Отправить код ещё раз',
    resendIn: 'Отправить ещё раз через {seconds} с',
    noLetter: 'Письма нет? Проверьте «Спам» и «Промоакции»',
    newClient: 'Ещё не работали с нами? Войдите так же — покажем услуги и цены',
    consentBefore: 'Принимаю условия ',
    consentOffer: 'оферты',
    consentMiddle: ' и даю согласие на обработку персональных данных по ',
    consentPrivacy: 'политике конфиденциальности',
  },
  nav: {
    home: 'Главная',
    projects: 'Проекты',
    documents: 'Документы',
    finance: 'Финансы',
    messages: 'Сообщения',
    services: 'Услуги',
    requests: 'Заявки',
    profile: 'Профиль',
    menu: 'Меню',
    toSite: 'На сайт',
  },
  home: {
    greeting: 'Здравствуйте, {name}',
    greetingAnonymous: 'Здравствуйте',
    projects: 'Проекты в работе',
    allProjects: 'Все проекты',
    nothingActive: 'Сейчас проектов в работе нет',
    soon: 'Скоро здесь появится всё по вашим проектам',
    soonText:
      'Что нужно от вас, как идут проекты, документы и счета — раздел наполняется. Пока всё приходит на почту, как обычно',
    feed: 'Последние события',
    feedEmpty: 'Событий пока нет — здесь появятся документы, счета и сданные этапы',
    feedKinds: {
      document_sent: 'Отправили документ',
      document_signed: 'Документ подписан',
      invoice_issued: 'Выставили счёт',
      payment_received: 'Получили оплату',
      stage_done: 'Этап сдан',
      project_done: 'Проект сдан',
      proposal_sent: 'Отправили предложение',
      progress_posted: 'Показали прогресс',
    },
  },
  projects: {
    title: 'Проекты',
    lead: 'Как идут работы: этапы, сроки и что уже сдано',
    active: 'В работе',
    finished: 'Завершённые',
    all: 'Все проекты',
    emptyTitle: 'Проектов пока нет',
    emptyText: 'Когда договоримся о работе, проект появится здесь — с этапами и сроками',
    statuses: {
      planning: 'Планируем',
      active: 'В работе',
      paused: 'На паузе',
      delivering: 'Сдаём',
      done: 'Завершён',
    },
    kinds: { fixed: 'Проект', tm: 'Почасовая работа', subscription: 'Сопровождение' },
    progress: 'Этапов сдано: {done} из {total}',
    current: 'Сейчас: {stage}',
    due: 'Срок — {date}',
    started: 'Начали {date}',
    deliveredOn: 'Сдали {date}',
    stages: 'Этапы',
    stagesHint: {
      title: 'Этапы проекта',
      text: 'Работа разбита на этапы из договора. Сданный этап отмечен галочкой; если этап ждёт оплаты, следующий начнётся после неё',
      example: '«Дизайн» сдан → «Разработка» начнётся после оплаты второй части',
    },
    stageDone: 'Сдан',
    stageCurrent: 'Сейчас',
    stageNext: 'Дальше',
    stageWaiting: 'Ждёт оплаты',
    stagePaid: 'Оплачен',
    noStages: 'Этапы появятся, когда менеджер распланирует работу',
    back: 'Все проекты',
  },
  subscription: {
    title: 'Сопровождение',
    tariff: 'Тариф «{name}»',
    tariffNone: 'Сопровождение',
    hoursMonth: '{hours} ч в месяц',
    perMonth: '{price} в месяц',
    perYear: '{price} в год',
    period: 'С {from}',
    periodTill: 'С {from} по {till}',
    statuses: {
      pending: 'Начнётся после сдачи проекта',
      active: 'Действует',
      paused: 'На паузе',
      ended: 'Закончилось',
    },
    used: 'Использовано {used} из {pool} ч',
    over: 'Сверх тарифа в этом месяце: {hours} ч',
    burn: '{date} сгорят неиспользованные {hours} ч',
    hint: {
      title: 'Как считаются часы',
      text: 'Каждый месяц начисляются часы тарифа. Неиспользованные часы переходят дальше и сгорают через несколько месяцев. Часы сверх тарифа оплачиваются отдельно',
      example: 'Осталось 6 ч от сентября — они сгорят 30 ноября, если не потратить',
    },
    tickets: 'Обращения',
    ticketsEmpty: 'Обращений пока нет — напишите менеджеру, если что-то нужно',
    ticketStatuses: { queue: 'Принято', in_progress: 'В работе', review: 'Проверяем', done: 'Готово' },
  },
  documents: {
    title: 'Документы',
    lead: 'Договоры, акты, счета и предложения — всё, что мы вам отправляли',
    filters: { all: 'Все', contracts: 'Договоры', invoices: 'Счета', acts: 'Акты', proposals: 'КП' },
    kinds: {
      offer: 'Оферта',
      order: 'Заявка',
      specification: 'Спецификация',
      invoice: 'Счёт',
      act: 'Акт',
      amendment: 'Допсоглашение',
      other: 'Документ',
    },
    states: {
      awaits: 'Ждёт вашей подписи',
      studio: 'На подписи у студии',
      signed: 'Подписан',
      sent: 'Отправлен',
      void: 'Аннулирован',
      expired: 'Срок подписи истёк',
      declined: 'Отклонён',
      revoked: 'Отозван',
    },
    number: '№ {number}',
    from: 'от {date}',
    download: 'PDF',
    sign: 'Подписать',
    signHint: {
      title: 'Как подписать',
      text: 'Откроется страница подписания: документы можно прочитать и подписать кодом из письма — это простая электронная подпись, она равна собственноручной по договору',
      example: 'Нажали «Подписать» → пришёл код на почту → ввели его — готово',
    },
    emptyTitle: 'Документов пока нет',
    emptyText: 'Когда мы отправим договор, счёт или акт, он появится здесь',
    emptyFilter: 'В этом разделе пока пусто',
    proposals: 'Коммерческие предложения',
    proposalOpen: 'Открыть',
    proposalSent: 'Отправлено {date}',
    proposalValid: 'действует до {date}',
    proposalExpired: 'срок истёк {date}',
    proposalAnswers: { none: 'Ждёт ответа', selected: 'Вы выбрали', declined: 'Не подошло' },
    opening: 'Открываем…',
  },
  finance: {
    title: 'Финансы',
    lead: 'Счета, оплаты и реквизиты для перевода',
    paid: 'Оплачено',
    left: 'Ждёт оплаты',
    overdue: 'Просрочено',
    invoices: 'Счета',
    invoice: 'Счёт № {number}',
    invoiceFrom: 'от {date}',
    dueOn: 'оплатить до {date}',
    statuses: {
      unpaid: 'Ждёт оплаты',
      partial: 'Оплачен частично',
      paid: 'Оплачен',
      overpaid: 'Оплачен',
      overdue: 'Просрочен',
    },
    partial: 'Оплачено {paid} из {amount}',
    pdf: 'PDF',
    howToPay: 'Как оплатить',
    purpose: 'Назначение платежа',
    purposeText: 'Оплата по счёту № {number} от {date}',
    copy: 'Скопировать',
    copied: 'Скопировано',
    requisites: 'Реквизиты',
    recipient: 'Получатель',
    inn: 'ИНН',
    kpp: 'КПП',
    bank: 'Банк',
    bik: 'БИК',
    account: 'Расчётный счёт',
    correspondent: 'Корр. счёт',
    payHint: {
      title: 'Когда платёж отметится',
      text: 'Оплату мы видим по выписке банка — обычно на следующий рабочий день. Укажите назначение платежа как здесь, тогда счёт закроется сам',
      example: 'Перевели во вторник — в среду счёт станет «Оплачен»',
    },
    cardSoon: 'Оплата картой и по СБП появится позже',
    payCard: 'Оплатить картой',
    payCardAmount: 'Оплатить {amount} картой',
    payCardOpening: 'Открываем оплату…',
    payCardHint: 'Картой или по СБП на странице Т-Банка — счёт закроется сразу после оплаты',
    payTest: 'Тестовый режим: деньги не спишутся',
    payDolyame: 'Оплатить долями — 4 × {part}',
    payDolyameHint: 'Четыре платежа раз в две недели, без переплаты — через сервис «Долями» Т-Банка',
    autopay: 'Автоплатёж для подписки «{title}»',
    autopayHint:
      'Следующие счета подписки спишутся с этой карты сами. Отключить можно в любой момент здесь же',
    invoiceOnly: 'Для организаций — оплата по счёту на реквизиты',
    autopays: {
      title: 'Автоплатежи',
      card: 'Карта {pan}',
      cardUnknown: 'Сохранённая карта',
      since: 'с {date}',
      disable: 'Отключить',
      disabling: 'Отключаем…',
      disabled: 'Автоплатёж отключён — следующие счета придут для оплаты',
    },
    paySuccess: {
      title: 'Спасибо, оплата прошла',
      text: 'Счёт отметится оплаченным, как только банк подтвердит платёж, — обычно за несколько секунд',
    },
    payFail: {
      title: 'Оплата не прошла',
      text: 'Деньги не списаны. Попробуйте ещё раз или оплатите по реквизитам',
    },
    payments: 'История оплат',
    paymentFor: 'по счёту {invoices}',
    paymentAdvance: 'аванс',
    emptyTitle: 'Счетов пока нет',
    emptyText: 'Когда мы выставим счёт, он появится здесь с реквизитами для оплаты',
    noPayments: 'Оплат пока не было',
  },
  needs: {
    title: 'Нужно от вас',
    empty: 'Сейчас от вас ничего не нужно — мы работаем',
    sign: 'Подписать: {title}',
    proposal: 'Ответить на предложение {title}',
    pay: 'Оплатить счёт {title} — {amount}',
    payOverdue: 'Срок оплаты прошёл',
    payAction: 'Реквизиты',
    until: 'до {date}',
    signAction: 'Подписать',
    signer: 'Подписывает {name} — код подтверждения придёт ему на почту',
    proposalAction: 'Открыть',
    task: 'Задание: {title}',
    approval: 'Согласовать: {title}',
    itemAction: 'Открыть',
  },
  items: {
    needs: 'Нужно от вас по проекту',
    progress: 'Ход работ',
    progressLead: 'Что уже сделано — скриншоты и пара слов от команды',
    list: 'Задания и согласования',
    kinds: { task: 'Задание', approval: 'На согласование', progress: 'Прогресс' },
    statuses: {
      open: 'Ждём вас',
      submitted: 'Вы ответили',
      done: 'Принято',
      pending: 'Ждёт согласования',
      approved: 'Согласовано',
      changes: 'Вы прислали замечания',
      published: 'Прогресс',
    },
    actions: {
      answer: 'Ваш ответ',
      approve: 'Вы согласовали',
      changes: 'Ваши замечания',
      accept: 'Команда приняла',
      return: 'Команда вернула',
      resend: 'Новая версия',
    },
    until: 'до {date}',
    round: 'Версия {round}',
    from: '{name}, {date}',
    open: 'Открыть',
    history: 'Как было',
    answerTitle: 'Ваш ответ',
    answerPlaceholder: 'Напишите ответ или приложите файлы',
    answer: 'Отправить ответ',
    approve: 'Согласовать',
    changes: 'Есть замечания',
    changesPlaceholder: 'Что поправить',
    changesSend: 'Отправить замечания',
    cancel: 'Отмена',
    attach: 'Приложить файлы',
    sent: 'Отправили команде',
    approved: 'Согласовано — команда продолжит работу',
    approveHint: {
      title: 'Что значит «Согласовать»',
      text: 'Вы подтверждаете, что этот вариант подходит и команда может делать дальше. Если что-то не так — «Есть замечания»: команда поправит и пришлёт новую версию',
      example: 'Макет главной согласован — дизайнер переходит к внутренним страницам',
    },
    emptyProgress: 'Команда покажет здесь, как идёт работа',
  },
  messages: {
    title: 'Сообщения',
    lead: 'Переписка с командой — по каждому проекту отдельно',
    chats: 'Разговоры',
    general: 'Общие вопросы',
    generalHint: 'Не про конкретный проект',
    back: 'Все разговоры',
    new: 'Есть новые сообщения',
    emptyTitle: 'Напишите нам',
    emptyText:
      'Ответит ваш менеджер, обычно в течение рабочего дня. Если вас не будет в кабинете, пришлём письмо, когда ответим',
    placeholder: 'Сообщение',
    send: 'Отправить',
    attach: 'Прикрепить файлы',
    attachHint: 'До 10 файлов, каждый — до 25 МБ',
    removeFile: 'Убрать файл',
    uploading: 'Загружаем…',
    fileTooLarge: 'Файл «{name}» больше 25 МБ — пришлите ссылку на облако',
    filesLimit: 'В одном сообщении — не больше 10 файлов',
    uploadFailed: 'Не загрузился «{name}»',
    earlier: 'Показать раньше',
    you: 'Вы',
    deleted: 'Сообщение удалено',
    edited: 'изменено',
    sending: 'Отправляем…',
    sent: 'Доставлено',
    read: 'Прочитано',
    replyManager: 'Вам ответит {name}',
    replyPersonal: 'Вам ответит ваш персональный менеджер',
    failed: 'Не отправилось',
    retry: 'Повторить',
    discard: 'Убрать',
    today: 'Сегодня',
    yesterday: 'Вчера',
    enterHint: 'Enter — отправить, Shift + Enter — новая строка',
    writeProject: 'Написать по проекту',
    open: 'Открыть файл',
    kb: '{value} КБ',
    mb: '{value} МБ',
  },
  manager: {
    title: 'Ваш менеджер',
    call: 'Позвонить',
    write: 'Написать',
  },
  services: {
    title: 'Услуги',
    lead: 'Выберите, что нужно, — менеджер свяжется и пришлёт предложение с точной ценой',
    priceFrom: 'от {price}',
    priceOnRequest: 'Рассчитаем под задачу',
    priceHint: {
      title: 'Почему «от»',
      text: 'Цена «от» — за базовый объём работ. Точную сумму менеджер посчитает под вашу задачу и пришлёт в предложении',
      example: 'Сайт-визитка «от 120 000 ₽» с каталогом на 200 товаров будет дороже',
    },
    select: 'Выбрать',
    selected: 'Выбрано',
    more: 'Подробнее',
    back: 'Все услуги',
    cases: 'Похожие проекты',
    caseOpen: 'Открыть проект',
    emptyTitle: 'Витрина пока пустая',
    emptyText: 'Расскажите, что нужно, — подберём решение и пришлём предложение',
    unavailableTitle: 'Услуга больше не показывается',
    unavailableText: 'Посмотрите другие услуги или опишите задачу своими словами',
    chosen: {
      one: 'Выбрана {count} услуга',
      few: 'Выбрано {count} услуги',
      many: 'Выбрано {count} услуг',
      other: 'Выбрано {count} услуги',
    },
    request: 'Оставить заявку',
    requestCustom: 'Описать задачу своими словами',
  },
  request: {
    title: 'Заявка',
    lead: 'Менеджер свяжется в рабочее время и пришлёт предложение',
    services: 'Услуги',
    noServices: 'Без выбранных услуг — опишите задачу в комментарии',
    remove: 'Убрать',
    name: 'Как к вам обращаться',
    phone: 'Телефон',
    phoneHint: 'Необязательно — если удобнее созвониться',
    company: 'Компания',
    companyHint: 'Необязательно',
    comment: 'Комментарий',
    commentPlaceholder: 'Что нужно сделать, сроки, ссылки на примеры',
    send: 'Отправить заявку',
    sent: 'Заявка отправлена — менеджер скоро свяжется',
  },
  requests: {
    title: 'Мои заявки',
    lead: 'Что вы оставляли и где это сейчас',
    emptyTitle: 'Заявок пока нет',
    emptyText: 'Выберите услуги на витрине или опишите задачу своими словами',
    toServices: 'К услугам',
    noServices: 'Задача своими словами',
    statuses: {
      received: 'Получили',
      preparing: 'Менеджер готовит предложение',
      proposal: 'Отправили предложение',
      working: 'Работаем',
      closed: 'Закрыта',
    },
    statusHint: {
      received: 'Заявка в очереди — менеджер возьмёт её в рабочее время',
      preparing: 'Менеджер разбирается в задаче и считает предложение',
      proposal: 'Предложение пришло на почту — его можно открыть и ответить там',
      working: 'Договорились — проекты появятся в кабинете',
      closed: 'Заявка закрыта. Нужно снова — оставьте новую',
    },
  },
  profile: {
    title: 'Профиль',
    email: 'Почта для входа',
    name: 'Имя',
    phone: 'Телефон',
    company: 'Компания',
    notSet: 'Не указано',
    clientHint: 'Имя и компанию ведёт ваш менеджер — напишите ему, если что-то изменилось',
    signOut: 'Выйти',
    signOutAll: 'Выйти на всех устройствах',
    signOutAllHint: 'Завершит вход на телефоне, планшете и других компьютерах',
    signedOutAll: 'Вы вышли на всех устройствах',
  },
  studio: {
    contacts: 'Связаться со студией',
  },
  states: {
    loading: 'Загружаем…',
    close: 'Закрыть',
    info: 'Пояснение',
    errorTitle: 'Не получилось загрузить',
    networkError: 'Нет связи — проверьте интернет и попробуйте снова',
    retry: 'Повторить',
    notFoundTitle: 'Такой страницы нет',
    notFoundText: 'Возможно, ссылка устарела. Всё нужное — на главной кабинета',
    toHome: 'На главную',
    signedOut: 'Сессия закончилась — войдите снова',
  },
} as const;

/** Ошибки кабинета (ключи `errors.cabinet.*`). */
export const ruCabinetErrors = {
  email_invalid: 'Проверьте почту — похоже, в адресе опечатка',
  code_format: 'Код — это 6 цифр из письма',
  code_invalid: 'Код не подошёл. Осталось попыток: {left}',
  code_expired: 'Код устарел — запросите новый',
  code_too_many: 'Попытки кончились — запросите новый код',
  code_wait: 'Новый код можно запросить через {seconds} с',
  signed_out: 'Сессия закончилась — войдите снова',
  blocked: 'Доступ этого контакта в кабинет закрыт — сначала откройте его',
  service_unavailable: 'Эта услуга больше не показывается — обновите страницу',
  request_too_many: 'В одной заявке — не больше 20 услуг',
  request_empty: 'Выберите услугу или напишите, что нужно',
  site_type_unknown: 'Такого вида проекта нет — обновите страницу',
  site_module_invalid: 'Модуль не распознан — обновите страницу',
  site_multiplier_invalid: 'Множитель — от ×0,5 до ×5',
  site_service_missing: 'Такой услуги в каталоге больше нет — обновите страницу и выберите другую',
  consent_required: 'Отметьте согласие с офертой и обработкой персональных данных — без него войти нельзя',
  comment_too_long: 'Комментарий — не длиннее {max} знаков',
  name_required: 'Как к вам обращаться? Укажите имя',
  name_too_long: 'Имя — не длиннее {max} знаков',
  company_too_long: 'Название компании — не длиннее {max} знаков',
  phone_invalid: 'Проверьте телефон — например, +7 999 123-45-67',
  message_empty: 'Напишите сообщение',
  message_too_long: 'Сообщение — не длиннее {max} знаков',
  message_files_limit: 'В одном сообщении — не больше {max} файлов',
  requests_limit: 'Сегодня заявок уже много — мы скоро свяжемся. Срочно — напишите нам на почту',
} as const;

/** «История» клиента (ключи `audit.actions.client.*`). */
export const ruCabinetClientAudit = {
  cabinet_invited: 'Приглашение в кабинет',
  cabinet_blocked: 'Закрыт доступ в кабинет',
  cabinet_unblocked: 'Открыт доступ в кабинет',
} as const;

/** Блок «Кабинет» в карточке клиента (ключи `cabinet.*`). */
export const ruCabinetStaff = {
  title: 'Личный кабинет',
  hint: {
    title: 'Как клиент входит в кабинет',
    text: 'Любой контакт клиента с почтой входит сам: вводит почту на странице кабинета и получает код. Пароля нет. «Пригласить» отправит письмо со ссылкой на вход. «Закрыть доступ» сразу завершит все входы контакта, и код на его почту больше не придёт',
    example: 'Бухгалтер клиента видит счета и акты сам — не нужно пересылать их письмом',
  },
  open: 'Открыть кабинет',
  empty: 'У контактов нет почты — добавьте почту контакту, и он сможет войти',
  neverSignedIn: 'Не входил',
  signedIn: 'Входил {times}, последний раз — {date}',
  times: { one: '{count} раз', few: '{count} раза', many: '{count} раз', other: '{count} раза' },
  blocked: 'Доступ закрыт',
  invite: 'Пригласить',
  invited: 'Приглашение отправлено на {email}',
  block: 'Закрыть доступ',
  blockedDone: 'Доступ закрыт: {name} больше не войдёт в кабинет',
  unblock: 'Открыть доступ',
  unblockedDone: 'Доступ открыт',
  chatTitle: '{client} — кабинет',
  chatLabel: 'Переписка с клиентом',
  dealChatLabel: 'Переписка по КП',
  dealChatEmptyTitle: 'Переписки по КП пока нет — клиент пишет со страницы предложения',
  chatOpen: 'Переписка',
  chatOpenHint:
    'Общая переписка с клиентом в его кабинете. Переписка по проекту — на вкладке «Клиент» в карточке проекта',
  projectTab: 'Клиент',
  projectTabLead:
    'Переписка с клиентом в его личном кабинете: клиент видит только эту ленту. Внутренний чат проекта ему не виден',
  projectChatEmptyTitle: 'Клиент ещё не писал по проекту',
  projectChatEmptyText:
    'Напишите первым — клиент увидит сообщение в кабинете, а если не зайдёт за 15 минут, получит письмо',
  clientChatEmptyTitle: 'Переписки в кабинете ещё нет',
  clientChatEmptyText: 'Здесь общие вопросы клиента — не по конкретному проекту',
  notifications: {
    waitingTitle: '{client} ждёт ответа {hours}',
    waitingBodyGeneral: 'Сообщение в личном кабинете без ответа — ответьте клиенту',
    waitingBodyProject: 'Сообщение по проекту «{project}» без ответа — ответьте клиенту',
  },
  requestTitle: 'Заявка из кабинета: {services}',
  requestTitleEmpty: 'Заявка из кабинета',
  requestNote: 'Кабинет клиента',
  requestNoteServices: 'Услуги: {services}',
  requestNotePhone: 'Телефон: {phone}',
  requestNoteComment: 'Комментарий: {comment}',
  /** Заявка с конфигуратора на лендинге (подпроект 11). */
  site: {
    title: 'Заявка с сайта: {type}',
    titleContact: 'Заявка с сайта',
    note: 'Конфигуратор на сайте',
    type: 'Проект: {type}',
    modules: 'Модули: {modules}',
    launch: 'Запуск: {date} ({urgency})',
    source: 'Исходные данные: {source}',
    estimate: 'Расчёт: {min} – {max}',
    noEstimate: 'Расчёт: посчитать вручную',
    city: 'Город по IP: {city}',
    comment: 'Сайт: {type}{modules}',
    commentModules: ' — {modules}',
    types: {
      site: 'Создание сайта',
      promo: 'Лендинг / промо',
      ai: 'AI-решения',
      mobile: 'Мобильная разработка',
    },
    sources: {
      ready: 'всё продумано',
      concept: 'есть концепция',
      idea: 'только идея',
    },
    urgencies: {
      urgent: 'срочный',
      optimal: 'оптимальный',
      delayed: 'отложенный',
    },
  },
} as const;
